module.exports = __webpack_public_path__ + "img/sydwfrzs_img.4d253bcc.png";